<template>
  <div class="check-cast">
    <!-- <h2>Check previous cast</h2> -->
    <div class="card">
      <div class="card-header">
        <h2 class="card-title">Check previous cast</h2>
      </div>
      <div class="card-body" v-show="web3jsInited">
        <div class="input-group mb-3">
          <div class="input-group-prepend">
            <span class="input-group-text" id="sha256-prefix">SHA256: 0x</span>
          </div>
          <input v-model="sha256" type="text" class="form-control" placeholder="Media SHA256" aria-label="Media SHA256 to check" aria-describedby="basic-addon2">
          <div class="input-group-append">
            <button class="input-group-btn btn-secondary" :disabled="!checkCastActive" @click="checkCastWeb3">Query details</button>
          </div>
        </div>
      </div>
      <div class="card-body" v-show="error">
        <p class="card-body-header error-message header">
          <span class="text-danger">{{ error }}</span>
        </p>
        <p class="card-body-text error-message">
          <span class="text-dark">Please enable MetaMask and login into the MainNet.</span>
        </p>
      </div>
    </div>

    <div v-if="checkCastResult">
      <table class="table"><tbody><tr><th>key</th><th>value</th></tr>
        <tr><td>cast_creator</td><td>{{ checkCastResult._cast_creator }}</td></tr>
        <tr><td>cast_owner</td><td>{{ checkCastResult._cast_owner }}</td></tr>
        <tr><td>description</td><td><pre>{{ checkCastResult._description}}</pre></td></tr>
      </tbody></table>
    </div>
    <div class="card" v-if="checkCastResultOwner">
      <div class="card-header">
        <h2 class="card-title">Update cast</h2>
      </div>
      <div class="card-body" v-show="web3jsInited">
        <div class="update-block">
          <span class="input-group-text" id="transfer-account">New description</span>
          <div class="input-group lg-3">
            <textarea v-model="newDescription" type="text" class="form-control description"
                      :placeholder="checkCastResult._description"
                      :rows="updateDescriptionRows"
                      :cols="updateDescriptionCols"
                      aria-label="New description"
                      aria-describedby="basic-addon3"
            ></textarea>
          </div>
          <button class="btn-lg btn-secondary px-5 update-block-element" :disabled="!updateDescriptionActive" @click="updateDescription">Update description</button>
        </div>
        <div class="update-block">
          <div class="input-group lg-3">
            <div class="input-group-prepend">
              <span class="input-group-text" id="transfer-account">Target Address 0x</span>
            </div>
            <input v-model="transferAddress" type="text" class="form-control" placeholder="Account address to transfer to" aria-label="Account address to transfer to" aria-describedby="basic-addon2">
            <div class="input-group-append">
              <button class="input-group-btn btn-secondary" :disabled="!transferCastActive" @click="transferOwnership">Transfer ownership</button>
            </div>
          </div>
        </div>
      </div>
      <div class="card-body" v-show="transferCastError || updateDescriptionError">
        <p class="card-body-header error-message header">
          <span v-if="transferCastError" class="text-danger">{{ transferCastError }}</span>
          <span v-if="updateDescriptionError" class="text-danger">{{ updateDescriptionError }}</span>
        </p>
      </div>
    </div>

  </div>
</template>

<script>
  import Vue               from 'vue'
  import { mapActions
         , mapGetters
         , mapState      } from 'vuex'
  const sha256RegExp = new RegExp('^[a-f0-9]{64}$', 'i')

  export default {
    name: 'CheckCast'
  , data () {
      return {
        sha256: null
      , error: null
      , transferAddress: null
      , newDescription: null
      }
    }
  , computed: {
      ...mapState(['contractArgs'])
    , ...mapState(['checkCastResult', 'transferCastError', 'transferCastResult'])
    , ...mapState(['updateDescriptionError', 'updateDescriptionResult'])
    , ...mapState(['web3jsInited', 'web3network', 'web3account', 'web3Error', 'web3Transaction'])
    , checkCastActive() {
        return this.sha256 && this.sha256.length == 64 && sha256RegExp.test(this.sha256)
      }
    , transferCastActive() {
        return /^[a-fA-F0-9]{40}$/.test(this.transferAddress)
      }
    , checkCastResultOwner() {
        return this.checkCastResult &&
               this.checkCastResult._cast_owner &&
               this.checkCastResult._cast_owner == this.web3account
      }
    , updateDescriptionActive() {
        return this.newDescription && 0 < this.newDescription.length // && 4096 >= this.newDescription.length
      }
    , updateDescriptionRows() {
        const rows = this.checkCastResult._description
                   ? (this.checkCastResult._description.match(/\r?\n/g) || []).length
                   : 10
        return rows < 10 ? 10 : rows
      }
    , updateDescriptionCols() {
        return (this.checkCastResult._description || '')
                .split(/\r?\n/)
                .map(s => s.length)
                .reduce((max, l) => (max > l ? max : l), 80)
      }
    }
  , methods: {
      ...mapActions([ 'initWeb3JS', 'getAccount', 'checkCastReset', 'checkCast', 'getGasPrice' ])
    , ...mapActions([ 'transferCastReset',      'transferCastOwnership' ])
    , ...mapActions([ 'updateDescriptionReset', 'updateCastDescription' ])
    , checkCastWeb3() {
        // console.log('checkCast')
        return this.checkCastReset().then(() =>
          this.getAccount().then(result => {
            if (!result) {
              this.error = "No active Web3 account selected"
            } else {
              this.updateDescriptionReset()
              this.transferCastReset()
              this.newDescription = null
              this.checkCast(this.sha256)
            }
          }))
      }
    , transferOwnership() {
        return this.transferCastOwnership({ sha256: this.sha256, target: this.transferAddress })
      }
    , updateDescription() {
        return this.updateCastDescription({ sha256: this.sha256, description: this.newDescription })
      }
    }
  , mounted () {
      if (this.contractArgs && this.contractArgs.sha256 && this.contractArgs.sha256.length) {
        this.sha256 = this.contractArgs.sha256
      }
      return this.checkCastReset().then(() =>
        this.initWeb3JS().then(
          result =>
            result
            ? this.getAccount().then(() => this.getGasPrice())
            : (this.error = "Web3 is unavailable", this.error)
        )
      )
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  button[disabled] {
    opacity: 0.75;
  }
  .error-message.header {
    font-size: 24pt;
  }
  .error-message {
    font-size: 16pt;
  }
  textarea.description {
    font-family: monospace;
  }
</style>



// WEBPACK FOOTER //
// src/components/CheckCast.vue